import type { schemaType as StrapiEscapadasDetailSchemaType } from '~~/shared/api/strapi/escapadas/detail/schema'
import type { schemaType as StrapiCottagesPagechemaType } from '~~/shared/api/strapi/cottages-page/schema'
import type { propsInterface as sShortDescriptionWrapperProps } from '~~/modules/design-system/sections/s-short-description/s-short-description-wrapper.vue'

export const useToSShortDescriptionWrapper = () => {
  const fromStrapiEscapadasDetail = (params: {
    dataIn: StrapiEscapadasDetailSchemaType
  }): sShortDescriptionWrapperProps => {
    let items: sShortDescriptionWrapperProps['items'] = []
    if (params.dataIn.attributes.intro_seo_text) {
      items = params.dataIn.attributes.intro_seo_text.map(item => ({
        title: item.title,
        description: {
          text: item.text,
        },
      }))
    }

    return { items }
  }

  const fromStrapiCottagesPage = (params: {
    dataIn: StrapiCottagesPagechemaType
  }): sShortDescriptionWrapperProps => {
    let items: sShortDescriptionWrapperProps['items'] = []
    if (params.dataIn.attributes.intro_seo_text) {
      items = params.dataIn.attributes.intro_seo_text.map(item => ({
        title: item.title,
        description: {
          text: item.text,
        },
      }))
    }

    return { items }
  }

  return { fromStrapiEscapadasDetail, fromStrapiCottagesPage }
}
